(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function jsonToHtmlTable(jsonData) {
      // If jsonData is a string, parse it. Otherwise, assume it's already an object.
      const data = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;

      if (!data || typeof data !== 'object' || !data.title || !Array.isArray(data.sizes) || !Array.isArray(data.data)) {
        return "<p>Invalid JSON structure. Required properties: 'title' (string), 'sizes' (array), 'data' (array).</p>";
      }

      let html = "<table border='1' style='border-collapse: collapse; width: 100%;'>\n";

      // Header row
      html += '  <thead>\n';
      html += '    <tr>\n';
      html += `      <th style='padding: 8px; border: 1px solid #ddd;'>${data.title}</th>\n`;
      data.sizes.forEach((sizeLabel) => {
        html += `      <th style='padding: 8px; border: 1px solid #ddd;'>${sizeLabel}</th>\n`;
      });
      html += '    </tr>\n';
      html += '  </thead>\n';

      // Data rows
      html += '  <tbody>\n';
      data.data.forEach((item) => {
        if (!item || typeof item !== 'object' || !item.measurement) {
          return; // Skip malformed items
        }
        html += '    <tr>\n';
        html += `      <td style='padding: 8px; border: 1px solid #ddd;'>${item.measurement}</td>\n`;
        data.sizes.forEach((sizeLabel) => {
          const value = item[sizeLabel] !== undefined ? item[sizeLabel] : '';
          html += `      <td style='padding: 8px; border: 1px solid #ddd;'>${value}</td>\n`;
        });
        html += '    </tr>\n';
      });
      html += '  </tbody>\n';

      html += '</table>';
      return html;
    }
    const sizeTableData = document.querySelector('[data-size-data]').dataset.sizeData;
    const htmlOutput = jsonToHtmlTable(sizeTableData);

    document.querySelector('.product-size-guide__table').innerHTML = htmlOutput;

    let currentUnit = 'cm'; // Assuming default is CM
    const tableCells = document.querySelectorAll('.product-size-guide__table tbody td:not(:first-child)'); // Select all td in tbody, excluding the first column (measurement labels)

    document.querySelector('[data-to-cm]').addEventListener('click', function () {
      if (currentUnit === 'in') {
        tableCells.forEach((cell) => {
          const value = parseFloat(cell.textContent);
          if (!isNaN(value)) {
            cell.textContent = (value * 2.54).toFixed(1); // IN to CM
          }
        });
        currentUnit = 'cm';
        this.classList.add('active');
        document.querySelector('[data-to-in]').classList.remove('active');
      }
    });

    document.querySelector('[data-to-in]').addEventListener('click', function () {
      if (currentUnit === 'cm') {
        tableCells.forEach((cell) => {
          const value = parseFloat(cell.textContent);
          if (!isNaN(value)) {
            cell.textContent = (value / 2.54).toFixed(1); // CM to IN
          }
        });
        currentUnit = 'in';
        this.classList.add('active');
        document.querySelector('[data-to-cm]').classList.remove('active');
      }
    });

    // Set initial active state for the CM button
    document.querySelector('[data-to-cm]').classList.add('active');
  });
  } catch(e) { console.error(e); }
})();

})();
